
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import logoImg from '../../img/Imagen3.png'
import vsbLogo from '../../assets/vsb-logo.jpeg'

export const ReportPDF = (report, date) => {
  console.log(report)
    const doc = new jsPDF('landscape','mm'); // Configura la página en orientación horizontal

    // Estilo para el encabezado
    doc.setFontSize(14);
    //doc.setFillColor(220, 220, 220); // Color de fondo suave
    doc.text('VSB RD', 148, 10, {align: 'center'});
    doc.setFontSize(8);
    doc.text('Reporte de Venta', 148, 15, {align: 'center'});
    doc.text(date.init!==''? 'Del '+new Date(`${date.init}T00:00:00`).toLocaleDateString('es-ES')+ 'Al '+new Date(`${date.end}T00:00:00`).toLocaleTimeString('es-ES'): `${(new Date()).toDateString('es-ES')} ${new Date().getHours().toString().padStart(2,'0')}:${new Date().getMinutes().toString().padStart(2,'0')}:${new Date().getSeconds().toString().padStart(2,'0')}`, 148, 20, {align: 'center'});
   // doc.addImage(logoImg, 'PNG', 10, 10, 50, 50);
    // Datos para la tabla
    const tableData1 = ['Num', 'Puntos', 'Clientes', 'Ciudad', 'Tickets', 'Apostado', 'Ganado','Pagado', 'No pagado', 'Recargas','Retiros','Bce en Caja','Jackpot Pagado', 'Resultados', 'Balance (%)']
    const tableData =  report.map(z =>[
        report.indexOf(z)+1,
        z.name,
        z.customer.name.split(' ')[0],
      //  z.address.street,
        z.address.city,
        z._static && z._static.amountBetted!=null? z._static.counterTicket:'',
        z._static && z._static.amountBetted!=null? parseFloat(z._static.amountBetted).toLocaleString('en-EN',{maximumFractionDigits:2}):'',
        z._static && z._static.amountPaid!=null? parseFloat(z._static.amountWinned).toLocaleString('en-EN',{maximumFractionDigits:2}):'',
        z._static && z._static.amountPaid!=null? parseFloat(z._static.amountPaid).toLocaleString('en-EN',{maximumFractionDigits:2}):'',
        z._static && z._static.amountPaid!=null? parseFloat(z._static.noPaid).toLocaleString('en-EN',{maximumFractionDigits:2}):'',
        z._static && z._static.amountPaid!=null? parseFloat(z._static.dep).toLocaleString('en-EN',{maximumFractionDigits:2}):'',
        z._static && z._static.amountPaid!=null? parseFloat(z._static.ret).toLocaleString('en-EN',{maximumFractionDigits:2}):'',
        z._static && z._static.amountPaid!=null? parseFloat(z._static.caja).toLocaleString('en-EN',{maximumFractionDigits:2}):'',
        z._static && z._static.jackpotPaid!=null? parseFloat(z._static.jackpotPaid).toLocaleString('en-EN',{maximumFractionDigits:2}):'',
        z._static && z._static.dif!=null? parseFloat(z._static.dif).toLocaleString('en-EN',{maximumFractionDigits:2}):'',
        `${z._static && z._static.rate!=null?parseFloat( z._static.rate).toFixed(2):''}%`
    ]).concat([['','Total', '', '', report.length>0? parseFloat(report.reduce((acum, current)=> current._static.counterTicket +acum,0)).toLocaleString('en-EN',{maximumFractionDigits:2}):0, 
    report.length>0? parseFloat(report.reduce((acum, current)=> current._static.amountBetted +acum,0)).toLocaleString('en-EN',{maximumFractionDigits:2}):0,
    report.length>0? parseFloat(report.reduce((acum, current)=> current._static.amountWinned +acum,0)).toLocaleString('en-EN',{maximumFractionDigits:2}):0,
    report.length>0? parseFloat(report.reduce((acum, current)=> current._static.amountPaid +acum,0)).toLocaleString('en-EN',{maximumFractionDigits:2}):0,
    report.length>0? parseFloat(report.reduce((acum, current)=> current._static.noPaid +acum,0)).toLocaleString('en-EN',{maximumFractionDigits:2}):0,
    report.length>0? parseFloat(report.reduce((acum, current)=> current._static.dep +acum,0)).toLocaleString('en-EN',{maximumFractionDigits:2}):0,
    report.length>0? parseFloat(report.reduce((acum, current)=> current._static.ret +acum,0)).toLocaleString('en-EN',{maximumFractionDigits:2}):0,
    report.length>0? parseFloat(report.reduce((acum, current)=> current._static.caja +acum,0)).toLocaleString('en-EN',{maximumFractionDigits:2}):0,
    report.length>0? parseFloat(report.reduce((acum, current)=> current._static.jackpotPaid +acum,0)).toLocaleString('en-EN',{maximumFractionDigits:2}):0, 
    report.length>0? parseFloat(report.reduce((acum, current)=> current._static.dif +acum,0)).toLocaleString('en-EN',{maximumFractionDigits:2}):0,
    `${report.length>0? (report.reduce((acum, current)=> current._static.dif +acum,0)*100/report.reduce((acum, current)=> current._static.amountBetted +acum,0)).toFixed(2):0}%`]])

    // Configuración de la tabla
    const tableConfig = {
      startY: 25,
      margin: { top: 1 },
    };

    doc.autoTable({
      head: [tableData1],
      body: tableData,
      startY: 25,
      theme: 'grid', // Sin color y con borde
      styles:{
        halign: 'left'
      },
      headStyles:{
        fillColor: [150, 150, 150], // Color de fondo del encabezado
        textColor: 0, // Color del texto
        fontStyle: 'bold',
      },
      columnStyles:{
        4:{halign: 'right'},
        5:{halign: 'right'},
        6:{halign: 'right'},
        7:{halign: 'right'},
        8:{halign: 'right'},
        9:{halign: 'right'},
        10:{halign: 'right'},
        11:{halign: 'right'},
        12:{halign: 'right'},
        13:{halign: 'right'},
        14:{halign: 'right'},
        15:{halign: 'right'}
      }
    });

    doc.output('dataurlnewwindow',{filename:'miPDF.pdf'});
  };

  
